
import Vue from "vue";

const END_POINT = "/module";

const getModule = id => Vue.axios.get(END_POINT + "/" + id);

const getAllModules = params => Vue.axios.get(END_POINT + "/search", {params});

const createModule = module => Vue.axios.post(END_POINT, module);

const updateModule = module => Vue.axios.put(END_POINT + "/" + module.id, module);

const deleteModule = id => Vue.axios.delete(END_POINT + "/" + id);

const getAccountModules = () => Vue.axios.get("/accountModule/", {
  params: {
    pageIndex: 0,
    pageSize: 100,
  }
});

const deactivateAccountModule = (moduleId) => Vue.axios.delete("/accountModule/" + moduleId);
const activateAccountModule = (moduleId) => Vue.axios.post("/accountModule/", {moduleId});


export {
  getModule,
  getAllModules,
  createModule,
  updateModule,
  deleteModule,
  getAccountModules,
  deactivateAccountModule,
  activateAccountModule
};
